module.exports = __webpack_public_path__ + "static/wallet-people-7fcc69bcbe0b577d3edcf4dc1349bff0.svg";